import app from '@/app';
import router from './global.router';

app.mixin(router);
